import { useState } from "react";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../../../common/DeleteModal";
import { useSelector } from "react-redux";
import editIcon from "../../../../images/icons/edit.svg";
import trashIcon from "../../../../images/icons/delete.svg";

const CardItem = ({ item, index, setShouldUpdate, selectTab, Service }) => {
	const [deleteModal, setDeleteModal] = useState(false);
	const navigate = useNavigate();
	const lang = useSelector((state) => state.auth?.lang);

	return (
		<tr key={index}>
			<td className="text-wrap-mode">{item[`name_${lang}`]}</td>
			<td className="text-wrap-mode">{item[`job_title_${lang}`]}</td>
			<td>
				<a href={item?.image} target="_blank" rel="noreferrer">
					<img src={item?.image} alt="leader" width={70} />
				</a>
			</td>
			<td>
				<div className="d-flex" style={{ gap: "20px" }}>
					<img
						src={editIcon}
						onClick={() => {
							navigate("/leadership-ourboard/add-leadership", {
								state: { type: selectTab, item: item },
							});
						}}
						className="cursor-pointer"
						alt="edit"
						width={24}
					/>
					<img
						src={trashIcon}
						onClick={() => setDeleteModal(true)}
						className="cursor-pointer"
						alt="trash"
						width={24}
					/>
				</div>
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={item[`name_${lang}`]}
					deletedItem={item}
					modelService={Service}
					setShouldUpdate={setShouldUpdate}
					onCloseModal={setDeleteModal}
				/>
			)}
		</tr>
	);
};
export default CardItem;
